<template>
    <div class='main'>
        <div class="StackpaenlHor">
            <button class="LightButton " @click="loadingModelDialogVisible = true">加载模型</button>
            <button class="LightButton " @click="dialogVisible = true">过滤查找</button>
            <button class="LightButton " @click="getComponentProperty()">查看过滤列表</button>
            <button class="LightButton " @click="ChangeInfo()">修改信息</button>
            <button class="LightButton " @click="CompentPropertydialogVisible = true">属性面板</button>
            <button class="LightButton "
                @click="() => { this.loadingModel.Id = ['0', '100031044244']; loadModel() }">测试跳转</button>
            <button class="LightButton " @click="BIDialogVisible = true">Bi筛选</button>
            <button class="LightButton " @click=LightModelFun.zoomToBoundingBox()>视口跳转</button>
        </div>
        <div style="width:100%;height:100%;">
            <div class="LightModel" id="domId">
            </div>
            <div class="DataModel" id="DataId">
            </div>
        </div>

        <!-- 定义DOM元素，用于在该DOM元素中显示模型或图纸 -->
        <!--过滤器查找窗口-->
        <el-dialog title="过滤元素列表" :visible.sync="dialogVisible" width="350px">
            <el-form label-width="80px" label-position="left" style="text-align:left; ">
                <el-form-item label="流水">
                    <el-input v-model="seletedElement.area" placeholder="请选择">
                    </el-input>
                </el-form-item>
                <el-form-item label="楼层">
                    <el-input v-model="seletedElement.floor" placeholder="请选择">
                    </el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="seletedElement.catalog" placeholder="请选择">
                        <el-option v-for="item in catalog" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button class="button" type="primary" @click="selectedComponents(datas)"
                        style="margin-right:20px ;width: 200px;height: 40px;">过滤查找</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--构件属性-->
        <el-dialog class="Copoment-dialog" title="属性" :visible.sync="CompentPropertydialogVisible" width="300px"
            :modal="false" :close-on-click-modal="false">


        </el-dialog>
        <!--加载模型-->
        <div class='model' id="domId"></div>
        <el-dialog title="加载模型" :visible.sync="loadingModelDialogVisible" width="250px">
            <el-form label-width="10px" label-position="left" style="text-align:left; ">
                <el-form-item>
                    <el-cascader :options="ModelIds" :show-all-levels="false" v-model="loadingModel.Id"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button class="button" type="primary" @click="loadModel()"
                        style="margin-right:20px ;width: 200px;height: 40px;">加载</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--加载二维码-->
        <el-dialog title="构件二维码" :visible.sync="QRDialogVisible" width="300px" @opened="QRhandleOpen"
            @closed="QRhandleClose">
            <el-form label-width="10px" label-position="left" style="text-align:left; ">
                <div id="qrcode"></div>
            </el-form>
        </el-dialog>
        <!--侧边栏-->
        <el-drawer title=过滤结果 :visible.sync="Infodialog" direction="rtl" size="30%">
            <div class="StackpaenlHor">
                <button type="button" class="button" id="btnOverrideComponentsColorByObjectId"
                    @click="ChoseComponet(test)">构件着色</button>
                <button type="button" class="button" id="btnOverrideComponentsColorByObjectId"
                    @click="ChoseComponet(test)">构件着色</button>
            </div>

            <el-table :data="gridData">
                <el-table-column property="id" label="ID" width="150"></el-table-column>
                <el-table-column property="name" label="名称" width="200"></el-table-column>
            </el-table>
        </el-drawer>
        <!--Bi筛选器-->
        <el-dialog class="Copoment-dialog" title="Bi" :visible.sync="BIDialogVisible" width="300px">
            <el-form label-width="80px" label-position="left" style="text-align:left; ">
                <el-form-item label="X轴">
                    <el-select v-model="EChartModel.Eoption.biSelectedX" placeholder="请选择">
                        <el-option v-for="item in EChartModel.Eoption.biX" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Y轴">
                    <el-select v-model="EChartModel.Eoption.biSelectedY" placeholder="请选择">
                        <el-option v-for="item in EChartModel.Eoption.biY" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button class="button" type="primary"
                        @click="EChartModel.showBi(EChartModel.Eoption.biSelectedX, EChartModel.Eoption.biSelectedY)"
                        style="margin-left:-80px ;width: 260px;height: 40px;">显示</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>


<style scoped>
.LightModel {
    position: static;
    right: 0px;
    top: 50px;
    bottom: 0px;
    color: #ccc;
    background: gray;
    width: 100%;
    height: 98%;
}

.DataModel {
    position: static;
    right: 0px;
    top: 10px;
    bottom: 0px;
    color: #ccc;
    background: rgb(125, 162, 127);
    height: 25%;
    visibility: hidden;
}

.Copoment-dialog {
    position: fixed;
    left: auto;
    /* 取消左定位，因为我们要自定义位置 */
    top: -20px;
    right: 10px;
}

.el-row {
    margin-bottom: 2px;

}

.el-col {
    border-radius: 4px;

}

.bg-purple-dark {
    height: 45px;
    background: #99a9bf;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 20px;
    border: 2px solid black;
    padding: 5px;
}

.bg-purple-light {
    height: 45px;
    background: #e5e9f2;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 18px;
    border: 2px solid black;
    padding: 5px;
}
</style>
<script type="text/javascript">
import { Alert } from 'element-ui';
import * as echarts from 'echarts';
let app;
let viewer3D;
let model3D;
let datas;
let isOverrideComponentsColorByIdActivated = false;
export default {
    data: function () {
        return {
            EChartModel: {
                Eoption: {
                    title: {
                        text: ''
                    },
                    tooltip: {},
                    legend: {
                        data: ['混凝土方量']
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '混凝土方量',
                            data: [],
                            type: 'bar'
                        }
                    ],
                    biX: [{
                        value: 1,
                        label: '按流水划分'
                    }, {
                        value: 2,
                        label: '按楼层划分'
                    }, {
                        value: 3,
                        label: '按构件类别划分'
                    }],
                    biY: [{
                        value: 1,
                        label: '混凝土消耗量'
                    }],
                    biSelectedX: 1,
                    biSelectedY: 1
                },
                myChart: '',
                presentAllData: '',
                selectedIds: [],
                showBi: (biX, biY) => {
                    if (biX == 1) {
                        this.EChartModel.getDataByLiushui();
                        this.BIDialogVisible = false;
                    }
                    else if (biX == 2) {
                        this.EChartModel.getDataByFloor();
                        this.BIDialogVisible = false;
                    }
                    else if (biX == 3) {
                        this.EChartModel.getDataByType();
                        this.BIDialogVisible = false;
                    }
                },
                getDataByFloor: () => {
                    let datas = [];
                    let volumes = [];
                    this.$axios({
                        url: this.apiurl +
                            "LightModel/GetCompomentByFloor"
                    }).then((res) => {
                        if (res.status == 200) {
                            this.EChartModel.Eoption.presentAllData = res.data;
                            res.data.forEach(function (element) {
                                datas.push(element.Floor);
                                let v = 0;
                                element.Compoments.forEach(function (element) {

                                    v = v + parseFloat(element.Volume);
                                    //alert(JSON.stringify(v))
                                });
                                v = v.toFixed(1);
                                volumes.push(v);
                            });

                            this.EChartModel.Eoption.xAxis.data = datas;
                            this.EChartModel.Eoption.series[0].data = volumes;
                            this.EChartModel.Eoption.title.text = "按楼层统计";
                            this.EChartModel.flushData();
                        }
                    }, (err) => {
                    });
                },
                getDataByLiushui: () => {
                    let datas = [];
                    let volumes = [];
                    this.$axios({
                        url: this.apiurl +
                            "LightModel/GetCompomentByLiushui"
                    }).then((res) => {
                        if (res.status == 200) {
                            this.EChartModel.Eoption.presentAllData = res.data;
                            res.data.forEach(function (element) {
                                datas.push(element.Liushui);
                                let v = 0;
                                element.Compoments.forEach(function (element) {

                                    v = v + parseFloat(element.Volume);
                                    //alert(JSON.stringify(v))
                                });
                                v = v.toFixed(1);
                                volumes.push(v);
                            });

                            this.EChartModel.Eoption.xAxis.data = datas;
                            this.EChartModel.Eoption.series[0].data = volumes;
                            this.EChartModel.Eoption.title.text = "按流水统计";
                            this.EChartModel.flushData();
                        }
                    }, (err) => {
                    });
                },
                getDataByType: () => {
                    let datas = [];
                    let volumes = [];
                    this.$axios({
                        url: this.apiurl +
                            "LightModel/GetCompomentByType"
                    }).then((res) => {
                        if (res.status == 200) {
                            this.EChartModel.Eoption.presentAllData = res.data;
                            res.data.forEach(function (element) {
                                datas.push(element.Type);
                                let v = 0;
                                element.Compoments.forEach(function (element) {

                                    v = v + parseFloat(element.Volume);
                                    //alert(JSON.stringify(v))
                                });
                                v = v.toFixed(1);
                                volumes.push(v);
                            });

                            this.EChartModel.Eoption.xAxis.data = datas;
                            this.EChartModel.Eoption.series[0].data = volumes;
                            this.EChartModel.Eoption.title.text = "按构件类别统计";
                            this.EChartModel.flushData();
                        }
                    }, (err) => {
                    });
                },
                flushData: () => {
                    var chartDom = document.getElementById('DataId');

                    var model = document.getElementById('domId');
                    chartDom.style.visibility = "visible";
                    model.style.height = "75%";
                    //obj.style.height = "45%";
                    //model.style.height = "55%";


                    this.EChartModel.Eoption && this.EChartModel.myChart.setOption(this.EChartModel.Eoption);

                },
                selectedCompoments: (params) => {
                    console.log(this.EChartModel.Eoption.presentAllData);
                    model3D.restoreComponentsColorById(this.EChartModel.Eoption.selectedIds)
                    this.EChartModel.Eoption.selectedIds = [];
                    if (this.EChartModel.Eoption.title.text == "按楼层统计") {
                        this.EChartModel.Eoption.presentAllData.forEach((element) => {
                            if (element.Floor == params.name) {
                                element.Compoments.forEach((element) => {
                                    this.EChartModel.Eoption.selectedIds.push(this.EChartModel.extractNumber(element.Id));
                                });
                            }
                            else {

                            }
                        });
                        console.log(this.EChartModel.Eoption.selectedIds);
                        let color = new Glodon.Web.Graphics.Color("#EE799F", 0.8);
                        model3D.overrideComponentsColorById(this.EChartModel.Eoption.selectedIds, color);
                        // 根据Id修改构件透明度
                        model3D.overrideComponentsOpacityById(this.EChartModel.Eoption.selectedIds, 0.8);
                        viewer3D.render();
                    }
                    else if (this.EChartModel.Eoption.title.text == "按流水统计") {

                        this.EChartModel.Eoption.presentAllData.forEach((element) => {
                            if (element.Liushui == params.name) {
                                element.Compoments.forEach((element) => {
                                    this.EChartModel.Eoption.selectedIds.push(this.EChartModel.extractNumber(element.Id));
                                });
                            }
                            else {

                            }
                        });
                        console.log(this.EChartModel.Eoption.selectedIds);
                        let color = new Glodon.Web.Graphics.Color("#EE799F", 0.8);
                        model3D.overrideComponentsColorById(this.EChartModel.Eoption.selectedIds, color);
                        // 根据Id修改构件透明度
                        model3D.overrideComponentsOpacityById(this.EChartModel.Eoption.selectedIds, 0.8);
                        viewer3D.render();
                    }
                    else if (this.EChartModel.Eoption.title.text == "按构件类别统计") {
                        this.EChartModel.Eoption.presentAllData.forEach((element) => {
                            if (element.Type == params.name) {
                                element.Compoments.forEach((element) => {
                                    this.EChartModel.Eoption.selectedIds.push(this.EChartModel.extractNumber(element.Id));
                                });
                            }
                            else {

                            }
                        });
                        console.log(this.EChartModel.Eoption.selectedIds);
                        let color = new Glodon.Web.Graphics.Color("#EE799F", 0.8);
                        model3D.overrideComponentsColorById(this.EChartModel.Eoption.selectedIds, color);
                        // 根据Id修改构件透明度
                        model3D.overrideComponentsOpacityById(this.EChartModel.Eoption.selectedIds, 0.8);
                        viewer3D.render();
                    }
                },
                extractNumber(str) {
                    let result = str.split("-");
                    return result[2];
                }
            },
            Model: {
                CompomentData: "",
                getData() {
                    alert(JSON.stringify(this.CompomentData));
                },
            },
            LightModelFun: {
                boundingbox :{
                    min: {
                    "x": -9496.219279454494,
                    "y": -4299.299971053061,
                    "z": 999.9607157957682
                        },
                    max: {
                    "x": 8443.779875881222,
                    "y": 6382.751044860747,
                    "z": 9475.048556778615
                    }
                },
                zoomToBoundingBox: () =>{
                    alert(JSON.stringify(2));
                },

        },
            //WebSocket
            //轻量化基础数据
            testIndex: 0,
            // 侧边统计栏
            table: false,
            Infodialog: false,
            OtherData: [],
            loading: false,
            BIDialogVisible: false,
            loadingModelDialogVisible: false,
            CompentPropertydialogVisible: false,
            QRDialogVisible: false,
            test: [],
            gridData: [],
            loadingModel: {
                Id: '100031058116',
                project: '',
                building: '',
                viewToken: '',
            },
            ModelIds: [{
                label: '上海倍特',
                children: [{
                    value: '100031027379',
                    label: 'BTZB-BG-ST-1·0.rvt',
                }, {
                    value: '100031027373',
                    label: 'BTZB-BG-AR-1·0.rvt',
                }, {
                    value: '100031027361',
                    label: 'BTZB-4#-ST-1·0.rvt',
                }, {
                    value: '100031028071',
                    label: 'BTZB-4#-AR-1·0.rvt',
                }, {
                    value: '100031061292',
                    label: '沙盘.FBX',
                }
                ]
            }, {
                label: '中江医院',
                children: [{
                    value: '100031025426',
                    label: 'ZJYY-BG-ST-1·0.rvt',
                }, {
                    value: '100031025420',
                    label: 'ZJYY-2#-ST-2·0.rvt',
                }, {
                    value: '100031025408',
                    label: 'ZJYY-5#-ST-1·0.rvt',
                }, {
                    value: '100031025402',
                    label: 'ZJYY-3#-ST-1·0.rvt'
                    ,
                }, {
                    value: '100031058116',
                    label: 'Test-ZJYY-3#-ST-1·0(1).rvt'
                    ,
                }]
            }],
            projectList: [],
            BuildingList: [],
            gridDataName: "123",
            form: {
                name: '',
                region: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            formLabelWidth: '80px',
            timer: null,
            CopmentData: {
                Id: '空',
                Floor: '空',
                Area: '空',
                Type: '空',
                Material: '空',
                Volume: '空',
                Chager: '空',
                PlanTime: '空',
                ActulTime: '空'
            },
            // 侧边统计栏
            loginRules: {
                account: [{ required: true, message: "请输入账号", trigger: "blur" }],
                passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
            },
            dialogVisible: false,
            seletedElement: {
                area: '',
                floor: '',
                catalog: ''
            },
            catalog: [{
                value: '-2001320',
                label: '梁'
            }, {
                value: '123',
                label: '梁'
            }, {
                value: '1234567',
                label: '板'
            }, {
                value: '选项4',
                label: '柱'
            }, {
                value: '选项5',
                label: '门窗'
            }],
            area: [{
                value: '选项1',
                label: 'C30'
            }, {
                value: '选项2',
                label: 'B'
            }, {
                value: '选项3',
                label: 'C'
            }, {
                value: '选项4',
                label: 'D'
            }, {
                value: '选项5',
                label: 'E'
            }],
            floor: [{
                value: '选项1',
                label: 'F15'
            }, {
                value: '选项2',
                label: 'F1'
            }, {
                value: '选项3',
                label: 'F2'
            }, {
                value: '选项4',
                label: 'F3'
            }, {
                value: '选项5',
                label: 'F4'
            }],

        };
    },
    props: ["id"],
    methods: {
        fluseModel() {
            let viewToken = this.loadingModel.viewToken;
            // 初始化显示组件
            let options = new BimfaceSDKLoaderConfig();
            options.viewToken = viewToken;
            BimfaceSDKLoader.load(options, successCallback, failureCallback);
            const that = this;
            function successCallback(viewMetaData) {
                if (viewMetaData.viewType == "3DView") {
                    // ======== 判断是否为3D模型 ========        
                    // 获取DOM元素
                    let dom4Show = document.getElementById('domId');
                    dom4Show.innerHTML = '';
                    let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
                    webAppConfig.domElement = dom4Show;
                    // 设置全局单位
                    webAppConfig.globalUnit = Glodon.Bimface.Common.Units.LengthUnits.Millimeter;
                    // 创建WebApplication
                    app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
                    // 添加待显示的模型
                    app.addView(viewToken);
                    // 从WebApplication获取viewer3D对象
                    viewer3D = app.getViewer();

                    // 监听添加view完成的事件
                    viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
                        //自适应屏幕大小
                        window.onresize = function () {
                            viewer3D.resize(document.documentElement.clientWidth, document.documentElement
                                .clientHeight - 40);
                        }
                        // 调用viewer3D对象的Method，可以继续扩展功能
                        // 渲染3D模型
                        model3D = viewer3D.getModel();
                        viewer3D.render();
                        //viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked, getData);
                    });

                }
            }

            function failureCallback(error) {
                console.log(error);
            }
            function getData(data) {
                if (data.objectId > 0) {
                    that.$axios({
                        url: that.apiurl +
                            "LightModel/GetComponetInfoById?FileId=" + data.fileId + "&ComponetId=" + data.objectId
                    }).then((res) => {
                        if (res.status == 200) {
                            that.CompentPropertydialogVisible = true
                            that.CopmentData.Id = res.data.data.elementId;
                            that.CopmentData.Floor = res.data.data.properties[0].items[1].value;
                            that.CopmentData.Area = res.data.data.properties[3].items[5].value;
                            that.CopmentData.Type = res.data.data.name;
                            that.CopmentData.Material = res.data.data.properties[4].items[0].value;
                            that.CopmentData.Volume = res.data.data.properties[2].items[2].value;
                            that.CopmentData.Chager = '张三';
                            that.CopmentData.PlanTime = '2024/9/8';
                            that.CopmentData.ActulTime = '2024/9/7';

                        }
                    }, (err) => {
                    });
                }
                else {
                    that.CopmentData.Id = '空';
                    that.CopmentData.Floor = '空';
                    that.CopmentData.Area = '空';
                    that.CopmentData.Type = '空';
                    that.CopmentData.Material = '空';
                    that.CopmentData.Volume = '空';
                    that.CopmentData.Chager = '空';
                    that.CopmentData.PlanTime = '空';
                    that.CopmentData.ActulTime = '空';
                    that.CompentPropertydialogVisible = false;
                }
                // if (data.objectId.length > 0) {
                //     fetch("https://172.16.101.20:7220/api/LightModel/GetComponetInfoById?FileId=" + data.fileId + "&ComponetId=" + data.objectId).then(response => {
                //         if (!response.ok) {
                //             throw new Error('Network response was not ok');
                //         }
                //         return response.text();
                //     })
                //         .then(datas => {
                //             alert(JSON.stringify(datas));
                //         })
                //         .catch(error => {
                //             console.error('There was a problem with your fetch operation:', error);
                //         });
                //     {
                //         throw new Error('Network response was not ok');
                //     }
                //     return response.text();

                // };
            }


        },
        cancelForm() {
            this.loading = false;
            this.dialog = false;
            clearTimeout(this.timer);
        },
        getComponentProperty() {
            this.test.forEach(element =>
                this.gridData.push({ id: element, name: this.seletedElement.area + '-' + this.seletedElement.floor + '-' + this.seletedElement.catalog.value })
            ),
                this.Infodialog = true;
        },

        getFloors() {
            this.viewer3D.getModel().getFloors(function (objectdata) {
                alert(JSON.stringify(objectdata));
            });
        },

        getModelTree() {
            this.viewer3D.getModel().getModelTree(function (objectdata) {
                alert(JSON.stringify(objectdata));

            });
        },
        selectedComponents() {
            this.dialogVisible = false;
            this.gridData.length = 0;
            let conditions = [{
                '楼层': this.seletedElement.floor,
                '流水': this.seletedElement.area,
                'categoryId': this.seletedElement.catalog,
            }];
            model3D.getComponentsByConditions(conditions, (data) => {
                this.test = Object.values(data);
                this.test.forEach(element => this.gridData.push({ id: element, name: this.seletedElement.area + '-' + this.seletedElement.floor + '-' + this.findValueByLabel(this.catalog, this.seletedElement.catalog) }));
                this.Infodialog = true;

            }, () => { window.alert('error') });
            model3D.restoreComponentsColorById(this.test);
            viewer3D.render();
            this.setButtonText("btnOverrideComponentsColorByObjectId", "根据ID给构件着色");
            if (isOverrideComponentsColorByIdActivated) {
                isOverrideComponentsColorByIdActivated = !isOverrideComponentsColorByIdActivated;
            }

        },
        findValueByLabel(floors, value) {
            for (let floor of floors) {
                if (floor.value === value) {
                    return floor.label;
                }
            }
            // 如果没有找到，可以返回一个默认值或者null  
            return null;
        },

        ChoseComponet(arr) {
            let color = new Glodon.Web.Graphics.Color("#EE799F", 0.8);
            if (!isOverrideComponentsColorByIdActivated) {
                // 根据Id修改构件颜色及透明度
                model3D.overrideComponentsColorById(arr, color);
                // 根据Id修改构件透明度
                model3D.overrideComponentsOpacityById(arr, 0.8);
                viewer3D.render();
                this.setButtonText("btnOverrideComponentsColorByObjectId", "恢复颜色");
            } else {
                //恢复颜色
                model3D.restoreComponentsColorById(arr);
                viewer3D.render();
                this.setButtonText("btnOverrideComponentsColorByObjectId", "根据ID给构件着色");
            }
            isOverrideComponentsColorByIdActivated = !isOverrideComponentsColorByIdActivated;
        },
        setButtonText(btnId, text) {
            let dom = document.getElementById(btnId);
            if (dom != null && dom.nodeName == "BUTTON") {
                dom.innerText = text;
            }
        },
        loadModel() {
            console.log(this.loadingModel.Id);
            if (Array.isArray(this.loadingModel.Id)) {
                this.loadingModel.Id = this.loadingModel.Id[1];
            }
            console.log(this.loadingModel.Id);
            this.$axios({
                url: this.apiurl +
                    "LightModel/LoadModels?FileId=" + this.loadingModel.Id
            }).then((res) => {
                if (res.status == 200) {
                    this.loadingModel.viewToken = res.data;
                    this.fluseModel();
                    this.loadingModelDialogVisible = false;


                }
            }, (err) => {
            });
        },
        FristloadModel(code) {

            this.loadingModel.viewToken = code;
            this.fluseModel();
            this.loadingModelDialogVisible = false;
        },
        getComponetData(data) {
            this.$axios({
                url: this.apiurl +
                    "LightModel/GetComponetInfoById?FileId=" + data.fileId + "&ComponetId=" + data.objectId
            }).then((res) => {
                if (res.status == 200) {
                    alert(res.data.data)

                }
            }, (err) => {
            });
        },
        ChangeInfo() {
            let fileId = 100031026095;
            let elementId = 2287666;
            let centent = 'https://bimprism.zghxsjy.com/data/v2/files/100031026095/elements/1949040';
            this.$axios({
                url: 'https://bimprism.zghxsjy.com/data/v2/files/100031026095/elements/1949040',
                headers: { 'Authorization': 'Bearer cn-224924d4-e9a5-4bea-8fc7-d4d84c49291f' }
            }).then((res) => {
                alert(res);
            }, (err) => {
                console.log(1);
            });
        },
        QRhandleOpen() {
            document.getElementById("qrcode").innerHTML = "";
            var url = this.apiurl + "LightModel/ChangeComponetInfo?FileId=" + this.loadingModel.Id + "&ComponetId=" + this.CopmentData.Id
            new QRCode(document.getElementById("qrcode"), {
                text: url,
                width: 256,
                height: 256,
                colorDark: "#000000", // 前景色（深色部分）  
                colorLight: "#ffffff"  // 背景色（浅色部分） "http://www.baidu.com");            
            });
        },
        QRhandleClose() {

            let color;
            if (this.testIndex == 1) {
                color = new Glodon.Web.Graphics.Color("#FFFFFF", 0.8);
            }
            else if (this.testIndex == 2) {
                color = new Glodon.Web.Graphics.Color("#0000FF", 0.8);
            }
            else if (this.testIndex == 3) {
                color = new Glodon.Web.Graphics.Color("#238E23", 0.8);
            }
            else if (this.testIndex == 4) {
                color = new Glodon.Web.Graphics.Color("#FFFF00", 0.8);
            }
            else if (this.testIndex == 5) {
                color = new Glodon.Web.Graphics.Color("#FF0000", 0.8);
            }
            model3D.overrideComponentsColorById([this.CopmentData.Id], color);
            // 根据Id修改构件透明度
            model3D.overrideComponentsOpacityById([this.CopmentData.Id], 1);
            viewer3D.render();

        },
        Echart() {
            
            var chartDom = document.getElementById('DataId');
            this.EChartModel.myChart = echarts.init(chartDom, 'dark');
            this.EChartModel.myChart.on('click', (params) => { this.EChartModel.selectedCompoments(params) });
            window.addEventListener('resize', () => { this.EChartModel.myChart.resize(); });
            //var chartDom = document.getElementById('DataId');
            //this.EChartModel.myChart = echarts.init(chartDom,'dark');            
            //this.EChartModel.Eoption && this.EChartModel.myChart.setOption(this.EChartModel.Eoption);
            //this.EChartModel.myChart.on('click', function(params) {window.open('https://www.baidu.com/s?wd=' + encodeURIComponent(params.name));});
        },
    },
    name: 'lighttest',
    created() {
        this.FristloadModel(this.$route.params.id);
    },
    mounted() {
        // 组件挂载后，设置默认选中第一项
        this.seletedElement.area = "";
        this.seletedElement.floor = this.floor[0].label;
        this.seletedElement.catalog = this.catalog[0].value;
        this.Echart();
    }

}

</script>
